import { Flame } from 'lucide-react';

// Mirrors the backend's scoreTier() — kept duplicated in TS so the badge
// can render without an extra API call. Update both when thresholds change.
function tierFor(score: number): { label: string; bg: string; text: string } {
  if (score >= 75) return { label: 'Hot',    bg: 'bg-red-50',    text: 'text-red-600' };
  if (score >= 50) return { label: 'Warm',   bg: 'bg-amber-50',  text: 'text-amber-600' };
  if (score >= 25) return { label: 'Cold',   bg: 'bg-blue-50',   text: 'text-blue-600' };
  return                 { label: 'Frozen', bg: 'bg-slate-100', text: 'text-slate-500' };
}

interface Props {
  score: number;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  onClick?: () => void;
  className?: string;
}

export function ScoreBadge({ score, size = 'md', showLabel = true, onClick, className = '' }: Props) {
  const t = tierFor(score);
  const isInteractive = !!onClick;
  const Wrapper = isInteractive ? 'button' : 'span';

  const sizing = size === 'sm'
    ? 'text-[10px] px-1.5 py-0.5 gap-1'
    : 'text-xs px-2 py-1 gap-1.5';

  return (
    <Wrapper
      type={isInteractive ? 'button' : undefined}
      onClick={onClick}
      className={`inline-flex items-center rounded-full font-semibold border border-transparent ${t.bg} ${t.text} ${sizing} ${
        isInteractive ? 'cursor-pointer hover:border-current transition-all' : ''
      } ${className}`}
      title={`${t.label} lead — score ${score}/100`}
    >
      <Flame className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      <span>{score}</span>
      {showLabel && <span className="opacity-80">· {t.label}</span>}
    </Wrapper>
  );
}
